/**
 * ArrowBackIcon Component
 * 
 * Custom back arrow icon for navigation.
 */

import React from 'react';
import type { IconProps } from './types';

const ArrowBackIcon: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.833 10H4.167m0 0L10 15.833M4.167 10L10 4.167"
      stroke={color}
      strokeWidth={1.83502}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowBackIcon;
